
import {
  defineComponent,
  computed,
} from 'vue';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: false,
      default: () => null,
    },
    color: {
      type: String,
      required: false,
      default: () => 'primary',
    },
    textAlign: {
      type: String,
      required: false,
      default: () => 'center',
    },
    align: {
      type: String,
      required: false,
      default: () => 'center',
    },
    type: {
      type: String,
      required: false,
      default: () => 'default',
    },
    typeHover: {
      type: String,
      required: false,
      default: () => 'inherit',
    },
    colorHover: {
      type: String,
      required: false,
      default: () => 'inherit',
    },
    width: {
      type: String,
      required: false,
      default: () => 'auto',
    },
    rounded: {
      type: String,
      required: false,
      default: () => '1',
    },
    roundedHover: {
      type: String,
      required: false,
      default: () => 'inherit',
    },
    linkType: {
      type: String,
      required: false,
      default: 'page',
    },
    pageUrl: {
      type: String,
      required: false,
    },
    pageId: {
      type: String,
    },
    mediaId: {
      type: String,
      required: false,
      default: () => '0',
    },
    mediaUrl: {
      type: String,
      required: false,
      default: () => '0',
    },
    mediaAlt: {
      type: String,
      required: false,
      default: () => '',
    },
    url: {
      type: String,
      required: false,
    },
    anchor: {
      type: String,
      required: false,
    },
    small: {
      type: String,
      required: false,
      default: () => '0',
    },
    icon: {
      type: String,
      required: false,
      default: () => null,
    },
  },

  setup(props) {
    const classes = computed(() => {
      const btnClasses = [];

      if (props.type === 'outline') {
        btnClasses.push(`btn-outline-${props.color}`);
      } else {
        btnClasses.push(`btn-${props.color}`);
      }

      if (props.typeHover !== 'inherit') {
        if (props.typeHover === 'outline') {
          btnClasses.push(`btn-hover-outline-${props.colorHover === 'inherit' ? props.color : props.colorHover}`);
        } else {
          btnClasses.push(`btn-hover-${props.colorHover === 'inherit' ? props.color : props.colorHover}`);
        }
      } else if (props.colorHover !== 'inherit') {
        if (props.type === 'outline') {
          btnClasses.push(`btn-hover-outline-${props.colorHover}`);
        } else {
          btnClasses.push(`btn-hover-${props.colorHover}`);
        }
      }

      if (props.small === '1') {
        btnClasses.push('btn-sm');
      }

      if (props.rounded === '1') {
        btnClasses.push('btn-rounded');
      }

      if (props.roundedHover !== 'inherit') {
        btnClasses.push(`btn-hover-${props.roundedHover === '1' ? 'rounded' : 'squared'}`);
      }

      btnClasses.push(`text-${props.textAlign}`);

      if (props.align === 'end') {
        btnClasses.push('ms-auto');
      } else if (props.align === 'start') {
        btnClasses.push('me-auto');
      } else {
        btnClasses.push('mx-auto');
      }

      if (props.width === 'full') {
        btnClasses.push('w-100');
      }

      if (props.icon !== null) {
        btnClasses.push('btn--icon');
      }

      return btnClasses;
    });

    const isEmail = (email: string) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);

    const buttonUrl = computed<string>(() => {
      let url;

      switch (props.linkType) {
        case 'page':
          url = props.pageUrl;
          break;
        case 'document':
          url = props.mediaUrl;
          break;
        case 'url':
          if (props.url && isEmail(props.url) && props.url.indexOf('mailto:') !== 0) {
            url = `mailto:${props.url}`;
          }
          url = props.url;
          break;
        default:
          url = null;
      }

      url = `${url || ''}`.trim();

      const anchor = `${props.anchor || ''}`.trim();

      if (
        props.linkType !== 'document'
          && anchor.length
      ) {
        url = `${url}#${anchor}`;
      }

      return url;
    });

    const buttonTarget = computed<string>(() => {
      switch (props.linkType) {
        case 'document':
        case 'url':
          if (props.url?.indexOf('javascript') === 0) {
            return '_self';
          }
          return '_blank';

        default:
          return '_self';
      }
    });

    return {
      classes,
      buttonUrl,
      buttonTarget,
    };
  },
});
